<template>
  <fts-design-modal
    class="fts-widget-predefined-design-modal"
    ref="ftsWidgetPredefinedDesignModal"
  >
    <!-- title -->
    <template #title>
      <div class="design-modal-header-std__title">
        <font-awesome-icon :icon="['fas', 'table-cells-large']" class="design-modal-header-icon" />
        <div class="design-modal-header-name design-modal-header-name--flex-1">
          Predefined Card
        </div>
      </div>
    </template>
    <!-- description -->
    <template #description>
      <span class="design-modal-header-tag">Widget</span>
    </template>
    <!-- body -->
    <template #body>
      <div class="fts-row gutters">
        <div
          v-for="x in formData"
          :key="x.id"
          class="fts-col-6"
        >
          <div
            class="d-widget-predefined-card"
            :class="[{'d-widget-predefined-card--active': x.selected}, getClass(x.id)]"
            @click="x.selected = !x.selected"
          >
            <div class="d-widget-predefined-card-title">
              {{x.name}}
            </div>
            <fts-transition-fade>
              <div class="d-widget-predefined-state" v-if="x.selected">
                <font-awesome-icon :icon="['fas', 'circle-check']" class="fts-text-success" />
              </div>
            </fts-transition-fade>
          </div>
        </div>
      </div>
    </template>
    <!-- footer:right -->
    <template #footerRight>
      <!-- cancel -->
      <fts-btn
        text
        @click="beforeClose"
      >
        Cancel
      </fts-btn>
      <!-- done -->
      <fts-btn
        outline
        color="primary"
        @click="done"
      >
        <font-awesome-icon :icon="['fas', 'check']" /> Ok
      </fts-btn>
    </template>
  </fts-design-modal>
</template>

<script>
import changesets from 'diff-json';

import dashboardWidget from '../../commons/dashboardWidget';

import FTSBtn from '../../elements/FTSBtn';
import FTSDesignModal from '../../design/FTSDesignModal';
import FTSTransitionFade from '../../elements/transition/FTSTransitionFade';

export default {
  components: {
    "fts-btn": FTSBtn,
    "fts-design-modal": FTSDesignModal,
    "fts-transition-fade": FTSTransitionFade
  },
  data: () => ({
    formData: null,
    originalData: null,
    resolve: null,
  }),
  methods: {
    async show(formData) {
      this.formData = _.cloneDeep(dashboardWidget.predefinedCards);
      this.formData.forEach(x => {
        this.$set(x, 'selected', formData.some(y => y.id == x.id));
      });

      return new Promise(async (resolve) => {  
        this.resolve = resolve;
        this.$refs.ftsWidgetPredefinedDesignModal.show({
          beforeCloseHandler: () => {
            const diff = changesets.diff(this.formData, this.originalData);
            if (diff && diff.length) {
              this.$modal.show("dialog", {
                title: "Confirm discard changes",
                text: "Discard all changes?",
                buttons: [
                  { title: "Cancel" },
                  {
                    title: "Discard",
                    default: true,
                    handler: () => {
                      this.$modal.hide("dialog");
                      this.reset();
                    },
                  },
                ],
              });
            } else {
              this.reset();
            }
          }
        });

        this.$nextTick(() => {
          this.originalData = _.cloneDeep(this.formData);
        });
      });
    },
    beforeClose() {
      this.$refs.ftsWidgetPredefinedDesignModal.beforeClose();
    },
    done() {
      this.resolve && this.resolve(this.formData.filter(x => x.selected));
      this.reset();
    },
    reset() {
      this.$refs.ftsWidgetPredefinedDesignModal.close();
      Object.assign(this.$data, this.$options.data.apply(this));
    },
    getClass(id) {
      switch(id) {
        case 'myActivitiy':
          return 'd-widget-predefined-card--activity';
        case 'calendar':
          return 'd-widget-predefined-card--calender';
        case 'myTask':
          return 'd-widget-predefined-card--task';
        case 'myMention':
          return 'd-widget-predefined-card--mention';
        case 'myWatch':
          return 'd-widget-predefined-card--watch';
        case 'initialByMe':
          return 'd-widget-predefined-card--initial';
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.fts-widget-predefined-design-modal {
  .d-widget-predefined-card {
    position: relative;
    height: 5rem;
    margin-bottom: 1rem;
    padding: 0.75rem;
    border-radius: 0.5rem;
    transition: 0.3s ease-in-out;
    cursor: pointer;
    &.d-widget-predefined-card--calender {
      background-color: var(--fts-dashboard-calendar);
    }
    &.d-widget-predefined-card--task {
      background-color: var(--fts-dashboard-task);
    }
    &.d-widget-predefined-card--activity {
      border: 1px solid var(--fts-gray-100);
      background-color: var(--fts-card-background);
    }
    &.d-widget-predefined-card--mention {
      background-color: var(--fts-dashboard-mention);
    }
    &.d-widget-predefined-card--initial {
      background-color: var(--fts-dashboard-initial);
    }
    &:hover {
      box-shadow: var(--fts-elevation-1);
    }
    &.d-widget-predefined-card--active {
      box-shadow: var(--fts-elevation-2);
    }
  }
  .d-widget-predefined-card-title {
    font-weight: 500;
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
  .d-widget-predefined-state {
    position: absolute;
    top: 0.75rem;
    right: 0.75rem;
    display: flex;
    align-items: center;
    height: 1.25rem;
    font-size: 1rem;
  }
}
</style>